import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    loading: false,
    searchParams: {
        page: 1,
        count: 100,
        admin_id: "",
        start_date: new Date(),
        end_date: new Date(),
        refresh: false,
        ...getUserConfig("opLog")
    }
}

const opLogReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'OP_LOG':
            return {
                ...state,
                ...action.payload
            }
        case 'OP_LOG_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams, ...getUserConfig("opLog")
                }
            }
        default:
            return {...state};
    }
}

export default opLogReducer
